import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  display: flex;\n  gap: 8px;\n\n  @media (max-width: 1120px) {\n    max-width: 388px;\n  }\n  @media (max-width: 1080px) {\n    max-width: 100%;\n  }\n  @media (max-width: 768px) {\n    overflow-x: auto;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from "react";
import { useModal } from "src/utils/overlay";
import styled from "styled-components";
import { BottomDrawer } from "../modal/BottomDrawer";
import { AllowanceChip, AllowanceListTypeWithString, licenseAllowanceChipList } from "./AllowanceChip";
import { AllowanceListType, HandoutAllowanceChip, handoutAllowanceChipList, HandoutAllowanceListTypeWithString } from "./Handout/HandoutAllowanceChip";
export const AllowanceChipList = (param)=>{
    let { productType , studioVersion , isParsedByMl  } = param;
    const isStudio = useMemo(()=>studioVersion === "v2", [
        studioVersion
    ]);
    const isEditStudio = useMemo(()=>isStudio && isParsedByMl, [
        studioVersion,
        isParsedByMl
    ]);
    const isWriteStudio = useMemo(()=>isStudio && !isParsedByMl, [
        studioVersion,
        isParsedByMl
    ]);
    const [isDrawerOpen, { open: openDrawer , close: closeDrawer  }] = useModal("drawer-modal");
    const [drawerData, setDrawerData] = useState({
        key: AllowanceListType.selling,
        color: "info",
        hasInfo: true,
        link: "/",
        description: "라이선스를 구매하게 되면 해당 권리를 계약(1년간)하게 되는 것으로 1회 구매당 총 100개의 저작자료를 쏠북에서 판매할 수 있습니다."
    });
    if (productType === "handout") //FIXME handout만 임시로 변경된 컴포넌트 추후 모두 hanout 과 동일한 컴포넌트 사용예정
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Container, {
                children: handoutAllowanceChipList.map((item, idx)=>{
                    if (item.key === AllowanceListType.editStudio && !isEditStudio) return null;
                    if (item.key === AllowanceListType.writeStudio && !isWriteStudio) return null;
                    return /*#__PURE__*/ _jsx(HandoutAllowanceChip, {
                        handleDrawer: ()=>{
                            setDrawerData(item);
                            openDrawer();
                        },
                        chipItem: item,
                        productType: productType
                    }, "allowance-chip" + idx);
                })
            }),
            /*#__PURE__*/ _jsx(BottomDrawer, {
                title: HandoutAllowanceListTypeWithString[drawerData.key],
                onClose: closeDrawer,
                open: isDrawerOpen,
                text: drawerData.description,
                link: drawerData.link,
                linkTitle: drawerData.linkTitle,
                position: null,
                name: "drawer-modal"
            })
        ]
    });
    if (productType === "textbook" || "workbook") return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            licenseAllowanceChipList.map((item, idx)=>/*#__PURE__*/ _jsx(AllowanceChip, {
                    handleDrawer: ()=>{
                        setDrawerData(item);
                        openDrawer();
                    },
                    chipItem: item,
                    productType: productType
                }, "allowance-chip" + idx)),
            /*#__PURE__*/ _jsx(BottomDrawer, {
                title: AllowanceListTypeWithString[drawerData.key],
                onClose: closeDrawer,
                open: isDrawerOpen,
                text: drawerData.description,
                link: drawerData.link,
                linkTitle: drawerData.linkTitle,
                position: null,
                name: "drawer-modal"
            })
        ]
    });
    return null;
};
const Container = styled.div.withConfig({
    componentId: "sc-83f18a5d-0"
})(_templateObject());
